import { render } from "./PageDetails.vue?vue&type=template&id=9df5cfc4&scoped=true"
import script from "./PageDetails.vue?vue&type=script&lang=js"
export * from "./PageDetails.vue?vue&type=script&lang=js"

import "./PageDetails.vue?vue&type=style&index=0&id=9df5cfc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df5cfc4"]])

export default __exports__